import { useState, useEffect } from 'react';
import { makeCall } from 'utils/utils';
import WithMotion from 'components/withMotion';
import MaterialTable, { MTableToolbar } from '@material-table/core';
import { currencyRatesColumns as columns } from './initialData';
import { CurrencyRateData as Data } from './types';
import { Grid } from '@material-ui/core';
import { tableContainerStyles as useStyles } from 'styles/common';

function Container() {
  const classes = useStyles();
  const [shouldFetch, setShouldFetch] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<Data[]>([]);

  useEffect(() => {
    const getData = async () => {
      const response = await makeCall('currencies/rates', 'GET');
      setIsLoading(false);
      setData(response?.data.data);
      setShouldFetch(false);
    };
    if (shouldFetch) {
      getData();
    }
  }, [shouldFetch]);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12}>
        <MaterialTable
          title="Currency Rates"
          components={{
            Toolbar: (props) => (
              <div className={classes.toolbarWrapper}>
                <MTableToolbar {...props} />
              </div>
            ),
          }}
          options={{
            search: true,
            pageSize: 10,
          }}
          isLoading={isLoading}
          columns={columns}
          data={data}
        />
      </Grid>
    </Grid>
  );
}

export default WithMotion(Container);
